var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellLarge = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 107,
    fill: "none",
    viewBox: "0 0 108 107",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 4.458,
    d: "M29.247 39.99C30.648 27.375 41.309 17.833 54 17.833c12.69 0 23.352 9.542 24.753 22.155l1.123 10.104.029.257a35.7 35.7 0 0 0 4.917 14.396l2.577 4.295c2.339 3.898 3.508 5.846 3.256 7.446a4.46 4.46 0 0 1-1.543 2.724c-1.242 1.04-3.514 1.04-8.06 1.04H26.948c-4.546 0-6.818 0-8.06-1.04a4.46 4.46 0 0 1-1.543-2.724c-.252-1.6.917-3.548 3.256-7.446l2.577-4.295.133-.222a35.7 35.7 0 0 0 4.813-14.431z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeLinecap: "round",
    strokeWidth: 4.458,
    d: "M41.08 82.06c.763 3.317 2.442 6.25 4.778 8.34 2.336 2.092 5.198 3.225 8.142 3.225s5.806-1.133 8.142-3.225c2.336-2.09 4.015-5.023 4.777-8.34"
  })));
};
export default SvgBellLarge;